import { Checkbox, Card, Snackbar, Backdrop, Box, Button, CardContent, CardHeader, Container, Grid, Dialog, TextField, Typography, Stepper, Step, StepLabel } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import SendIcon from '@mui/icons-material/Send';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import UploadFile from '../../components/UploadFileForApplication';
import Photo from '../../components/Photo';
import Alert from 'src/components/Alert';
import SectionBlock from 'src/components/SectionBlock';

const DefaultConsumerChangeValue = {
    d: 0,
    CloseType: 0,
    ServiceType: '',
    CityLocation: '',
    ServiceLocation: '',
    Country: '',
    Town: '',
    PersonType: '',
    ServiceInfo: '',
    Devir: 0,
    Birlesme: 0,
    Subelesme: 0,
    Findeks: ''
};

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    actionsCCFile: {
        justifyContent: 'flex-end'
    }
};
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function CloseService() {
    const params = useParams();
    const [Loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [uyariAciklama, setUyariAciklama] = useState('');
    const SessionUser = getUser();
    const [comment, setComment] = useState("")
    const [servisKapanisTip, setservisKapanisTip] = useState([]);
    const [servisKisi, setServisKisi] = useState([]);
    const [servisKonum, setServisKonum] = useState([]);
    const [servisLokasyonIl, setServisLokasyonIl] = useState([]);
    const [servisLokasyonIlce, setServisLokasyonIlce] = useState([]);
    const [servisLokasyonKonum, setServisLokasyonKonum] = useState([]);
    const [servisTip, setServisTip] = useState([]);
    const [birimler, setbirimler] = useState([]);
    const [subebirim, setSubeBirim] = useState([]);
    const [birlesenBirimler, setBirlesenBirimler] = useState([]);
    const [closeTypeValue, setCloseTypeValue] = useState(0);
    const [personType, setPersonType] = useState(0);
    const [location, setlocation] = useState(0);
    const [locationCity, setLocationCity] = useState(0);
    const [locationType, setLocationType] = useState(0);
    const [serviceType, setServiceType] = useState(0);
    const [adaySayisi, setAdaySayisi] = useState(1);
    const [adaySayisiDosyaAdet, setadaySayisiDosyaAdet] = useState([]);
    const [locationIlce, setLocationIlce] = useState(0);
    const [service, setService] = useState(0);
    const [subeler, setSubeler] = useState([]);
    const [subelesenBirim, setSubelesenBirim] = useState(0);
    const [ortaklasanBirim, setOrtaklasanBirim] = useState([]);
    const [fileList, setFileList] = React.useState([]);
    const [maxId, setMaxId] = useState(0);
    const [photoPopUp, setPhotoPopUp] = useState(false);
    const [formData, setFormdata] = useState(DefaultConsumerChangeValue);
    const [dosyaTipi, setDosyaTipi] = useState(1);
    const [fileTypeData, setFileTypeData] = React.useState([])
    const [uploadingFile, setUploadingFile] = useState([]);
    const [filesDataToSend, setFilesDataToSend] = useState([]);
    const [bolgeyeBagliSubeler, setBolgeyeBagliSubeler] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const stepLabels = ['Kapanış Bilgileri', 'Ek Bilgi', 'Dosyalar'];

    const handleCloseType = (cityValue) => {
        const data = {
            ItemValue: SessionUser.TopServiceShopCode,
            ItemId: 1,
            cityValue: cityValue?.Id
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('GetCatalogItemsForClose', data, config).then((response) => {
            if (response.data.length > 0) {
                const res = response.data[0]
                setLoading(false);
                setservisKapanisTip(res.KapanisTipi)
                setbirimler(res.BolgeyeBagliBirim)
                //res.BolgeyeBagliBirim'in Dsc'sinde "ŞUBE" kelimesi geçenleri bolgeyeBaliSubeler'e atıyoruz
                setBolgeyeBagliSubeler(res.BolgeyeBagliBirim.filter(item => item.Dsc.includes('ŞUBE')));
                setSubeBirim(res.SubeBirim)
                setMaxId(res.MaxId[0].Id)
            } else {
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });
    }


    // function handleDocumentType(itemValue) {
    //     if (itemValue.Id == 5) {
    //         setDosyaTipi(2);
    //         handleFileType(2);
    //     } else {
    //         setDosyaTipi(1);
    //         handleFileType(1);
    //     }
    // }


    useEffect(() => {
        handleCloseType()
    }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

    function servisKisiSayisi(value) {
        setAdaySayisi(value);
        var adet = value;
        var arr = [];
        for (var i = 0; i < adet; i++) {
            arr.push(i)
        }
        setadaySayisiDosyaAdet(arr);
    }

    const handleFileCloseType = (documentType) => {

        axios.get(`/GetFileCloseType/` + 1 + '/' + documentType)
            .then((response) => {
                const res = response.data;
                setFileTypeData(res);
            }).catch(error => {
            });
    }

    const showStepWarning = (message) => {
        setUyariAciklama(message);
        setUyariTip('error');
        setUyari(true);
        return false;
    };

    const validateStep = (step) => {
        if (step === 0) {
            if (closeTypeValue.Id == undefined || service.Id == undefined) {
                return showStepWarning('Lütfen ilgili alanları kontrol ediniz!!.');
            }
            if (subebirim.length > 0 && subeler.length < 1) {
                return showStepWarning('Merkezi kapatılan servisin şubesi açık olamaz. Lütfen ilgili şube/şubeleri seçiniz');
            }
            return true;
        }
        return true;
    };

    const handleNextStep = () => {
        if (validateStep(activeStep)) {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBackStep = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleApply = (event) => {
        if (closeTypeValue.Id == undefined || service.Id == undefined) {
            setUyariAciklama('Lütfen ilgili alanları kontrol ediniz!!.')
            setUyariTip('error')
            setUyari(true)
            return;
        }
        if (subebirim.length > 0 && subeler.length < 1) {
            setUyariAciklama('Merkezi kapatılan servisin şubesi açık olamaz. Lütfen ilgili şube/şubeleri seçiniz')
            setUyariTip('error')
            setUyari(true)
            return;
        }

        let differentTypeIds = [];
        fileTypeData.length > 0 && fileTypeData.reduce((acc, item) => {
            if (!uploadingFile.some(element => element.TypeId === item.ID) && (item.ZORUNLU === 1)) {
                differentTypeIds.push({
                    ID: item.ID, ACIKLAMA: item.ACIKLAMA
                });
            } return acc;
        }, []);
        if (differentTypeIds.length > 0) {
            setUyariAciklama(`Lütfen ${differentTypeIds[0].ACIKLAMA} dosyasını yükleyiniz!...`)
            setUyariTip('error')
            setUyari(true)
            return;
        }
        setLoading(true);
        const dataMessage = {
            CloseType: closeTypeValue.Id,
            Service: service.Id,
            ServiceInfo: comment,
            Subeler: subeler,
            UserId: "", //okta
            UploadFiles: uploadingFile.map((item) => ({
                ReceiptNumber: 0,
                AdaySayisiId: adaySayisi,
                FileName: item.FileName,
                FileType: item.FileType,
                FileData: item.FileData,
                TypeId: item.TypeId,
                CreateUser: "",
                OnOnay: 1,
                OpenClose: 2
            }))
        };
        const configMessage = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('/SetCloseApplication', dataMessage, configMessage).then(response => {
            let ResponseDataMessage = response.data[0];
            if (ResponseDataMessage.ErrorCode == "0") {
                setUyariAciklama(ResponseDataMessage.ErrorDescription);
                setUyari(true);
                setUyariTip("success")
                setCloseTypeValue(0);
                setComment('');
                setBirlesenBirimler([]);
                setServiceType(0);
                setLoading(false);
                ClearData();
                setActiveStep(0);
            } else {
                setUyariTip("error");
                setUyariAciklama(ResponseDataMessage.ErrorDescription);
                setUyari(true);
                setLoading(false);
            }
        }).catch(error => {
            setUyariAciklama("Bir hata oluştu!..")
            setUyariTip("error");
            setUyari(true);
            setLoading(false);
        });
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };


    function ClearData() {
        setCloseTypeValue(0);
        setServiceType(0);
        setLocationType(0);
        setLocationCity(0);
        setLocationType(0);
        setlocation(0);
        setLocationCity(0);
        setLocationIlce(0);
        setServiceType(0);
        setComment("");
        setService(0);
        setBirlesenBirimler([]);
        setOrtaklasanBirim([]);
        setSubeler([]);
        servisKisiSayisi(1);
        setMaxId(maxId + 2)
        setUploadingFile([]);
        setFileTypeData([]);
    }


    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={Loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
                </Alert>
            </Snackbar>
            <Container maxWidth="xl">
                <Card>
                    <CardHeader title="Servis Kapanış Talebi" subheader={'Id: ' + (maxId + 1)} />
                    <Divider />
                    <CardContent>
                        <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
                            {stepLabels.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>

                        {activeStep === 0 && (
                        <SectionBlock title="Kapanış Bilgileri">
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 3,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    value={closeTypeValue}
                                    options={servisKapanisTip}
                                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                    renderInput={(params) => <TextField {...params} label={('Kapanış Tipi')} variant="outlined" required />}
                                    onChange={(event, value) => {
                                        setCloseTypeValue(value);
                                        handleFileCloseType(value.Id);
                                    }}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 3,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    value={service}
                                    options={closeTypeValue.Id === 4 ? bolgeyeBagliSubeler : birimler}
                                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                    renderInput={(params) => <TextField {...params} label={('Servis')} variant="outlined" />}
                                    onChange={(event, value) => {
                                        setService(value);
                                        handleCloseType(value)
                                        setSubeler([])
                                    }}
                                />
                            </Grid>
                            {closeTypeValue.Id !== 4 ? (
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 3,
                                        lg: 2
                                    }}>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        fullWidth
                                        limitTags={1}
                                        disableCloseOnSelect
                                        value={subeler}
                                        options={subebirim}
                                        getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                        onChange={(event, value) => { setSubeler(value); }}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.Dsc}
                                            </li>
                                        )
                                        }
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                label={('Servis Şubeleri')}
                                                variant="outlined" />}
                                    />
                                </Grid>) : null}
                        </SectionBlock>
                        )}

                        {activeStep === 1 && (
                        <SectionBlock title="Ek Bilgi">
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    lg: 4
                                }}>
                                <TextField
                                    size="small"
                                    id="comment"
                                    value={comment}
                                    onChange={event =>
                                        setComment(event.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    label={'Servis Hakkında Bilgi'}
                                    helperText="Servisin neden kapandığına dair genel bilgilendirme (Servis sahibinin sağlık sorunu, iş gücü yetersizliği vb.)"
                                    variant="outlined"
                                    autoComplete='off'
                                />
                            </Grid>
                        </SectionBlock>
                        )}

                        {activeStep === 2 && (
                        <Box sx={{ backgroundColor: '#f7f8fa', borderRadius: 2, p: 2, mb: 2 }}>
                            <Typography
                                variant="overline"
                                sx={{ display: 'block', color: 'text.secondary', fontWeight: 700, letterSpacing: 0.75, lineHeight: 1.2, mb: 1 }}
                            >
                                Dosyalar
                            </Typography>
                            {closeTypeValue.Id !== 2 ? (
                                <UploadFile basvuruId={maxId + 1} documentType={fileTypeData} dosyaAdet={adaySayisi} documentTypeNumber={10}
                                    openClose={2} uploadingFile={uploadingFile} setUploadingFile={setUploadingFile} setFilesDataToSend={setFilesDataToSend} />
                            ) : (
                                <Typography sx={{ color: 'text.secondary' }}>
                                    Bu kapanış tipi için dosya yüklemesi gerekmemektedir.
                                </Typography>
                            )}
                        </Box>
                        )}

                        <Box sx={{ mt: 1, display: 'flex', gap: 1.5 }}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                startIcon={<ArrowBackIcon />}
                                disabled={activeStep === 0}
                                onClick={handleBackStep}
                            >
                                Geri
                            </Button>
                            {activeStep < stepLabels.length - 1 ? (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    endIcon={<ArrowForwardIcon />}
                                    onClick={handleNextStep}
                                >
                                    İleri
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    endIcon={<SendIcon />}
                                    onClick={() => {
                                        handleApply()
                                    }}
                                >
                                    ONAYA GÖNDER
                                </Button>
                            )}
                        </Box>
                    </CardContent>
                    <Dialog
                        open={photoPopUp}
                        fullWidth={true}
                        maxWidth={'xl'}
                        onClose={() => setPhotoPopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <Grid container >
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <Photo> </Photo>
                            </Grid>
                        </Grid>
                    </Dialog>
                </Card>
            </Container>
        </Page >
    );
}

export default CloseService;
